export interface ChatResponse {
  message: string;
  success: boolean;
}

export const sendMessageToAI = async (message: string, conversationHistory: Array<{ role: string; content: string }>): Promise<ChatResponse> => {
  try {
    // Usar la URL completa del servidor
    const endpoint = 'https://apichatbot.gobeapp.com/agent/quote';
    
    // Agregar el nuevo mensaje del usuario al historial
    const messages = [
      ...conversationHistory,
      {
        role: 'user',
        content: message,
      }
    ];
    
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messages,
        local: false,
        language: 'English',
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error del servidor:', response.status, errorText);
      throw new Error(`Error del servidor: ${response.status}`);
    }

    const data = await response.json();
    console.log('Respuesta del API:', data);
    
    // Extraer el mensaje del asistente de la respuesta
    let aiMessage = '';
    
    // Intentar diferentes estructuras de respuesta
    if (typeof data === 'string') {
      aiMessage = data;
    } else if (data.length > 0 && data[0].output) {
      aiMessage = data[0].output;
    } else if (data.content) {
      aiMessage = data.content;
    } else if (data.message) {
      aiMessage = data.message;
    } else if (data.response) {
      aiMessage = data.response;
    } else if (data.text) {
      aiMessage = data.text;
    } else if (data.messages && Array.isArray(data.messages) && data.messages.length > 0) {
      const lastMessage = data.messages[data.messages.length - 1];
      aiMessage = lastMessage.content || lastMessage.message || '';
    } else if (data.data && data.data.content) {
      aiMessage = data.data.content;
    } else {
      console.warn('Estructura de respuesta desconocida:', data);
      aiMessage = 'Response received but in unexpected format';
    }
    
    if (!aiMessage || aiMessage.trim() === '') {
      throw new Error('La respuesta del servidor está vacía');
    }
    
    return {
      message: aiMessage,
      success: true,
    };
  } catch (error) {
    console.error('Error en la conexión:', error);
    
    let errorMessage = '❌ We were unable to connect to the server.\n\n';
    
    if (error instanceof Error) {
      if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
        errorMessage += '🔍 Posibles causas:\n• El servidor no está disponible\n• Problemas de CORS\n• URL incorrecta\n\n💡 Solución: Verifica que el servidor esté corriendo y accesible desde esta URL.';
      } else if (error.message.includes('404')) {
        errorMessage = '❌ Endpoint no encontrado (404)\n\nVerifica que la ruta /agent/quote exista en tu servidor.';
      } else if (error.message.includes('500')) {
        errorMessage = '❌ Error interno del servidor (500)\n\nRevisa los logs de tu backend.';
      } else {
        errorMessage += `Detalles: ${error.message}`;
      }
    }
    
    return {
      message: errorMessage,
      success: false,
    };
  }
};
